import axios from 'axios';
import { API_BASE_URL } from '../constants';

export const axiosInstance = axios.create({ baseURL: String(API_BASE_URL) });

axiosInstance.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = `/auth/login?return${window.location.href}`;
    } else if (response.status === 403) {
      window.location.href = '/dashboard';
    }
    return response;
  },
  (error) => Promise.reject(error),
);

export const axiosGet = (url, config = {}, accessToken = localStorage.getItem('authToken')) => {
  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return axiosInstance.get(url, config);
};

export const axiosPost = (url, data, config = {}) => {
  const accessToken = localStorage.getItem('authToken');
  const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

  return axiosInstance.post(url, data, {
    ...config,
    headers: {
      ...config.headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      // Important: unset JSON content-type so multipart boundary is set automatically.
      ...(isFormData ? { 'Content-Type': undefined } : {}),
    },
  });
};

export const axiosPut = (url, data, config = {}) => {
  const accessToken = localStorage.getItem('authToken');
  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return axiosInstance.put(url, data, config);
};

export const axiosPatch = (url, data, config = {}) => {
  const accessToken = localStorage.getItem('authToken');
  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return axiosInstance.patch(url, data, config);
};

export const axiosDelete = (url, config = {}) => {
  const accessToken = localStorage.getItem('authToken');
  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return axiosInstance.delete(url, config);
};

const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const getApi = async ({ baseUrl, queryString = '', token }) => {
  const response = await fetch(`${baseUrl}?${queryString}`, {
    method: 'GET',
    headers: {
      ...DEFAULT_HEADERS,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  return await response.json();
};

export const postApi = async ({ baseUrl, body, token }) => {
  const response = await fetch(baseUrl, {
    method: 'POST',
    headers: {
      ...DEFAULT_HEADERS,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });

  return await response.json();
};

export const deleteApi = async ({ baseUrl, token }) => {
  const response = await fetch(baseUrl, {
    method: 'DELETE',
    headers: {
      ...DEFAULT_HEADERS,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  return response.json();
};
